import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const NiddriePage = () => <LocationTemplate suburbName="Niddrie" suburbSlug="niddrie" />;

export default NiddriePage;
